import { Injectable } from '@angular/core'

import { environment } from '../../environments/environment'
import type { FeatureFlag } from '../../environments/environment.interface'

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  isEnabled(flag?: FeatureFlag): boolean {
    if (flag) {
      const enabledFlags = environment.flags ?? []
      return enabledFlags.includes(flag)
    }
    return false
  }
}
